import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";

function CTLTableBodyCell({ noBorder, align, children }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const borderColor = darkMode ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.08)";

  return (
    <MDBox
      component="td"
      textAlign={align}
      py={0.75}
      px={1.5}
      sx={({ typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${borderColor}`,
      })}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

CTLTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

CTLTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default CTLTableBodyCell;
